import { styled } from '@linaria/react';
import { layout, semantic, space } from '../../theme/tokens';

export const Track = styled.div`
  display: flex;
  gap: ${space[1]};
  width: 100px;
`;

export const Segment = styled.span`
  flex: 1;
  height: 4px;
  border-radius: ${layout.borderRadiusFull};
  background: ${semantic.bg.surfaceStrong};

  &[data-active='true'] {
    background: ${semantic.bg.positiveStrong};
  }
`;
